import AmfModal from "../primitives/AmfModal"
import Vue from "vue";
import AmfButton from "../primitives/AmfButton";
import BasicModal from "../primitives/BasicModal";
import ListModal from "../primitives/ListModal";
import MultiLineInfoModal from "../primitives/MultiLineInfoModal";
import store from "../../store";
import metricsService from "./metrics-service";

class ModalService {

    info(text, extend = {}) {
        return this.show("basic-modal", BasicModal, { type: "info", text: text, ...extend });
    }

    confirm(text, extend = {}) {
        return this.show("basic-modal", BasicModal, { type: "confirm", text, ...extend });
    }

    passphrase(text, passphraseDescription, passphrase, extend = {}) {
        return this.show('basic-modal', BasicModal, { type: "passphrase", passphraseDescription, passphrase, text, ...extend });
    }

    discard(text, extend = {}) {
        return this.show("basic-modal", BasicModal, { type: "discard", text, ...extend });
    }

    input(text, initialValue, customTitle, extend = {}) {
        return this.show("basic-modal", BasicModal, { type: "input", text, initialValue, customTitle, ...extend});
    }

    multiLineInput(text, initialValue, customTitle, extend = {}) {
        return this.show("basic-modal", BasicModal, { type: "multiLineInput", text, initialValue, customTitle, ...extend });
    }

    multiSelect(text, initialValue, options, customTitle, extend = {}){
        return this.show("basic-modal", BasicModal, { type: "multiSelect", text, initialValue, options, customTitle, ...extend});
    }

    select(text, initialValue, options, customTitle, extend = {}) {
        return this.show("basic-modal", BasicModal, { type: "select", text, initialValue, options, customTitle, ...extend });
    }

    linkList(items, extend = {}) {
        return this.show("list-modal", ListModal, { type: "linkList", initialValue: items, ...extend });
    }

    multiLineInfo(lines = [], text = null, customTitle = null, errorStyle = false, extend = {}) {
        return this.show("multi-line-info-modal", MultiLineInfoModal, {type: "info", lines, text, title: customTitle, errorStyle, ...extend});
    }

    showResult(apiResult) {
        var customTitle = apiResult.success ? "Success" : "Error";
        if (!apiResult.messages || apiResult.messages.length == 0) return;
        if (apiResult.messages.length <= 5) {
            return this.info(apiResult.messages.join("<br>"), { customTitle });
        } else {
            return this.multiLineInfo(apiResult.messages, null, customTitle);
        }
    }

    show(componentName, componentClass, data) {
        return new Promise((resolve, reject) => {
            data = data || {};
            let width = data.width;
            let propertyStr = _.keys(data).map(p => `:${p}="${p}"`).join(" ");
            let components = {};
            components[_.camelCase(componentName)] = componentClass;
            components.AmfModal = AmfModal;

            this.getModalPlugin().show(
                {
                    template: `<amf-modal @close="close" @cancel="cancel" @loaded="childLoaded"><${componentName} ${propertyStr}></${componentName}></amf-modal>`,
                    props: _.keys(data),
                    components: components,
                    created() {
                        this.$store = store;
                    },
                    methods: {
                        childLoaded() {
                          metricsService.suspendActive();
                          metricsService.start('modal', componentName, this.$children[0]);
                        },
                        close: function(args) {
                          this.closeModal();
                          resolve(args);
                        },
                        cancel: function(){
                          this.closeModal();
                          reject();
                        },
                        closeModal: function() {
                          this.$emit("close"); //Have to emit a "close" event to the vue-js-modal plugin
                          metricsService.resumeSuspended();
                          metricsService.stop('modal', componentName, this.$children[0]);
                        }
                    },
                },
                data,
                {
                    draggable: false,
                    height: "auto",
                    clickToClose: false,
                    width: width || 600, //Will use default value https://euvl.github.io/vue-js-modal/Properties.html#properties-2
                }
            );
        });
    }

    getModalPlugin() {
        // this is a trick to get reference to vue-js-modal plugin
        var SomeComponent = Vue.extend(AmfButton);
        var instance = new SomeComponent();
        return instance.$modal;
    }

}

const modalService = new ModalService();

export { modalService }



// WEBPACK FOOTER //
// ./src/framework/utils/modal-service.js